import { nonEmptyStringValidator } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
/**
 * Default display text for the Site Picker component.
 */
export const defaultSitePickerDisplayText = {
    siteCountLabel: 'Showing ${siteCount} locations (select up to ${maximumSelectedSites})',
    siteCountLabelMaximumSelected: 'Showing ${siteCount} locations (maximum selected)',
    searchInputPlaceholder: 'Search by name or location',
    noSitesFoundForSearchTermMessage: 'Sorry, we couldn\'t find any locations matching "${searchTerm}".',
    failedToLoadDataTitle: 'Sorry, something went wrong.',
    failedToLoadDataMessage: 'Refresh your browser to try loading cinemas again.'
};
export const sitePickerDisplayTextValidator = Validator.object({
    siteCountLabel: nonEmptyStringValidator,
    siteCountLabelMaximumSelected: nonEmptyStringValidator,
    searchInputPlaceholder: nonEmptyStringValidator,
    noSitesFoundForSearchTermMessage: nonEmptyStringValidator,
    failedToLoadDataTitle: nonEmptyStringValidator,
    failedToLoadDataMessage: nonEmptyStringValidator
});
//# sourceMappingURL=display-text.js.map